module.exports = __webpack_public_path__ + "static/media/become-img-4-1.3d0efd1d.png";